import React, { useState, useEffect, useRef } from 'react';
import { SvgIcon } from '@material-ui/core';

const IconSvg = ({ name = 'default', ...props }) => {
  const ImportedIconRef = useRef(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    const importIcon = async () => {
      try {
        const namedImport = (
          await import(
            `!!@svgr/webpack?-svgo,+titleProp,+ref!../../../assets/icons/${name}.svg`
          )
        ).default;
        ImportedIconRef.current = namedImport;
      } catch (err) {
        throw err;
      } finally {
        setLoading(false);
      }
    };
    importIcon();
  }, [name]);

  if (!loading && ImportedIconRef.current) {
    const { current: ImportedIcon } = ImportedIconRef;

    return <SvgIcon component={ImportedIcon} {...props} />;
  }

  return <></>;
};

export default IconSvg;
